import ReactLib from '@owenscorning/react-library';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { setFormData } from '../../WarrantyStandardForm/redux/actions';
import YesNoTable from '../YesNoTable';

const {
  Connect: {
    Spinner,
    ReactUtils: { useLoading },
    FormElements: { Form, Text },
  },
} = ReactLib;

// just a little helper used here, could go to a util file
const decodeHtml = html => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

const apiUrl = `${MDMS_URL}/api/v2/contractor/warranties/roofing-component-options`;

const ComponentOptionsTable = ({ currentComponentSelections, setFormData }) => {
  const [loadWrapper, loading, loadError] = useLoading();
  const [componentOptions, setComponentOptions] = useState({});

  const fetchComponentOptions = loadWrapper(async () => {
    const response = await fetch(apiUrl).then(response => response.json());
    setComponentOptions(response);
    // default all options to faulse
    setFormData({
      components: _.reduce(
        response,
        (result, option) => {
          result[option.value] = currentComponentSelections[option.value] || 'NO';
          return result;
        },
        {}
      ),
    });
  });

  useEffect(() => {
    fetchComponentOptions();
  }, []);

  const transformedOptions = _.map(componentOptions || {}, option => ({
    key: option.value,
    tip: decodeHtml(option.example_text),
    title: decodeHtml(option.component),
  }));

  if (loading) {
    return <Spinner />;
  }

  return (
    <YesNoTable
      rows={transformedOptions}
      selections={currentComponentSelections}
      onChange={state => setFormData({ components: state })}
    />
  );
};

const mapStateToProps = state => ({
  currentComponentSelections: state.formData.components,
});

const mapDispatchToProps = dispatch => ({
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComponentOptionsTable);
